export const isPressing = new WeakSet<EventTarget>()
